import { render, staticRenderFns } from "./other-documents.vue?vue&type=template&id=3b35248f"
import script from "./other-documents.vue?vue&type=script&lang=js"
export * from "./other-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports